export const API_URL = "https://api.path.net";
export const FLOWS_URL = "https://flows-api.path.net/app/dashboards";
export const FLOWS_METRICS_TENANT = "infrastructure_metrics";
export const FLOWS_WAF_TENANT = "nginx_logs";
export const FLOWS_NETWORK_TENANT = "network_analytics";
export const FLOWS_METRICS_DASHBOARD = "Overview";
export const FLOWS_NETWORK_DASHBOARD = "Overview";
export default API_URL;
